module.exports = __webpack_public_path__ + "img/storebanner.0ad19ba0.png";